import {
  APPLICATION_GET,
  APPLICATION_UPDATE,
  APPLICATION_PAY,
  APPLICATION_BUY_REPORT,
  APPLICATION_SEND_PAYMENT_REQUEST,
  APPLICATION_GET_EXPERIAN_QUESTIONS,
  APPLICATION_ANSWER_EXPERIAN_QUESTIONS,
  APPLICATION_REQUEST,
  APPLICATION_SUCCESS,
  APPLICATION_ERROR,
  APPLICATION_PACKAGE_DOWNLOAD,
  APPLICATION_PDF_DOWNLOAD,
  APPLICATION_BUY_REPORTS_BY_APPLICANT,
  APPLICATION_GENERATE_FINICITY_CONNECT_URL,
  APPLICATION_SKIP_INCOME_VERIFICATION
} from "@/store/types"

import axios from "@/store/axios"

import JsZip from "jszip"
import { saveAs } from "file-saver"

import sampleApplication from "@/constants/sampleApplication"

const state = {
  currentApplication: null,
  isLoading: false,
  error: null,
  questions: null
}

const getters = {
  getCurrentApplication: (state) => state.currentApplication,
  getApplicationExperianQuestions: (state) => state.questions,
  isApplicationLoading: (state) => state.isLoading,
  getApplicationError: (state) => state.error
}

const actions = {
  [APPLICATION_GET]: ({ commit }, { id, edit = false }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_REQUEST, true)

      if (id === "sample") {
        commit(APPLICATION_SUCCESS, { current: sampleApplication })
        resolve()
        return
      }

      axios
        .get(`/api/v3/applications/${id}/${edit ? "?edit=True" : ""}`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_PAY]: ({ commit }, { id, token, receipt }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_REQUEST)

      axios
        .post(`/api/v3/applications/${id}/pay/`, {
          stripeToken: token,
          payment_receipt: receipt
        })
        .then((resp) => {
          console.log(resp)

          commit(APPLICATION_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_UPDATE]: ({ commit }, { id, data }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_REQUEST)

      axios
        .patch(`/api/v3/applications/${id}/`, data)
        .then((resp) => {
          console.log(resp)

          commit(APPLICATION_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUY_REPORT]: (
    { commit, state },
    { stripeToken, receipt, saveCard, identifiers }
  ) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_REQUEST)
      /*
        TODO: 'use_default_card': profile.card.use_default_card
      */

      const data = {
        stripeToken,
        payment_receipt: receipt,
        save_as_default: saveCard,
        profile_source_identifier: identifiers
      }

      axios
        .post(`/api/v3/applications/${state.currentApplication.id}/buy_report/`, data)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_SEND_PAYMENT_REQUEST]: ({ commit, state }, { identifiers }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_REQUEST)

      axios
        .post(`/api/v3/applications/${state.currentApplication.id}/send_payment_request/`, {
          report_source_identifiers: identifiers
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_PDF_DOWNLOAD]: ({ commit, state }, { save = true }) => {
    return new Promise((resolve, reject) => {
      const id = state.currentApplication.id
      const applicantName = state.currentApplication.applicant.name.replace(" ", "_").toLowerCase()

      axios
        .get(`/api/v3/applications/${id}/pdf/`, { responseType: "blob" })
        .then((resp) => {
          if (save) {
            saveAs(resp.data, `application__${id}__${applicantName}.pdf`)
          }

          commit(APPLICATION_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_PACKAGE_DOWNLOAD]: ({ commit, state }, { applicationBlob } = {}) => {
    return new Promise((resolve, reject) => {
      // Prevent isLoading toggle
      // commit(APPLICATION_REQUEST)
      const id = state.currentApplication.id
      const applicantName = state.currentApplication.applicant.name.replace(" ", "_").toLowerCase()

      const errors = []

      const requests = [
        applicationBlob
          ? new Promise((resolve) =>
              resolve({
                fileName: `application__${id}__${applicantName}.pdf`,
                blob: applicationBlob
              })
            )
          : axios
              .get(`/api/v3/applications/${id}/pdf/`, { responseType: "blob" })
              .then((resp) => {
                return {
                  fileName: `application__${id}__${applicantName}.pdf`,
                  blob: resp.data
                }
              })
              .catch(() => {
                errors.push({ type: "application" })
              }),
        ...state.currentApplication.attachment_urls.map((url) => {
          const formattedUrl = `/api/v3/attachments/download?path=${encodeURIComponent(
            url.split("?path=")[1]
          )}`
          return axios
            .get(formattedUrl, { responseType: "blob" })
            .then((resp) => {
              return {
                fileName: `attachment__${id}__${applicantName}__${
                  resp.headers["content-disposition"].replaceAll('"', "").split("filename=")[1]
                }`,
                blob: resp.data
              }
            })
            .catch(() => {
              errors.push({ type: "attachment" })
            })
        })
      ]

      if (state.currentApplication.reports_enabled) {
        state.currentApplication.reports
          .filter((r) => r.status === "ready")
          .map((r) => {
            requests.push(
              axios
                .get(`/api/v3/reports/${r.id}/pdf/`, { responseType: "blob" })
                .then((resp) => {
                  return {
                    fileName: `${r.report_type}_report__${id}__${applicantName}.pdf`,
                    blob: resp.data
                  }
                })
                .catch(() => {
                  errors.push({ type: "report" })
                })
            )
          })
      }

      Promise.all(requests)
        .then((blobs) => {
          const zip = JsZip()

          blobs.forEach((blob) => {
            if (blob) {
              zip.file(blob.fileName, blob.blob)
            }
          })

          zip.generateAsync({ type: "blob" }).then((zipFile) => {
            const fileName = `application_${id}__${applicantName}__combined.zip`
            return saveAs(zipFile, fileName)
          })
          commit(APPLICATION_SUCCESS)

          resolve(errors.length ? errors : null)
        })
        .catch((err) => {
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_GET_EXPERIAN_QUESTIONS]: (
    { commit },
    { id, firstName, lastName, ssn, streetAddress, city, state, zip }
  ) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_REQUEST)

      axios
        .post(`/api/v3/applications/${id}/get_experian_questions/`, {
          first_name: firstName,
          last_name: lastName,
          ssn,
          street_address: streetAddress,
          city,
          state,
          zip
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_SUCCESS, { questions: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_ANSWER_EXPERIAN_QUESTIONS]: ({ commit }, { id, answers }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_REQUEST)

      axios
        .post(`/api/v3/applications/${id}/answer_experian_questions/`, {
          answers
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_BUY_REPORTS_BY_APPLICANT]: ({ commit }, { id, token, receipt }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_REQUEST)

      axios
        .post(`/api/v3/applications/${id}/buy_reports_by_applicant/`, {
          stripeToken: token,
          payment_receipt: receipt
        })
        .then((resp) => {
          console.log(resp)

          commit(APPLICATION_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_GENERATE_FINICITY_CONNECT_URL]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_REQUEST)

      axios
        .post(`/api/v3/applications/${id}/generate_finicity_connect_url/`)
        .then((resp) => {
          console.log(resp)

          commit(APPLICATION_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_SKIP_INCOME_VERIFICATION]: ({ commit }, { id, reason, otherDetail }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_REQUEST)

      axios
        .post(`/api/v3/applications/${id}/skip_income_verify/`, {
          reason,
          other_detail: otherDetail
        })
        .then((resp) => {
          console.log(resp)

          commit(APPLICATION_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(APPLICATION_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [APPLICATION_REQUEST]: (state, refresh = false) => {
    state.isLoading = true

    if (refresh) {
      state.currentApplication = null
    }
  },
  [APPLICATION_SUCCESS]: (state, { current, questions } = {}) => {
    state.isLoading = false
    if (current) state.currentApplication = current
    if (questions) state.questions = questions
  },
  [APPLICATION_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err.message
    state.currentApplicationTemplate = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
